
export const MAX_FILE_SIZE = 2_000_000; //2MB

const allowedMIMETypes = ["image/png", "image/jpg", "image/jpeg", "image/gif", "image/svg"];
export const allowedFormatTypes = ['jpeg', 'png', 'jpg', 'gif', 'svg'];

export const byteValueNumberFormatter = Intl.NumberFormat("en", {
  notation: "compact",
  style: "unit",
  unit: "byte",
  unitDisplay: "narrow",
});

/**
 * A promise that resolves to image src string.
 * @param file File to convert.
 */
export function imgFromFile(file: File, maxFileSize = MAX_FILE_SIZE): Promise<string> {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    const fileValidation = validateImageFile(file, maxFileSize);
    if (fileValidation !== "valid") {
      reject(fileValidation)
    } else {
      reader.onload = () => {
        resolve(reader.result as string)
      };
    }
    reader.readAsDataURL(file);
  });
}

function validateImageFile(file: File, _maxFileSize = MAX_FILE_SIZE): FileValidationStateInvalid | FileValidationStateValid {
  let maxFileSize = _maxFileSize ?? MAX_FILE_SIZE;

  if (file.size > maxFileSize) {
    return "exceeded-size";
  }

  if (!_isOfAllowedType(file)) {
    return "wrong-format";
  }

  return "valid";
}

function _isOfAllowedType(file: File): boolean {
  return allowedMIMETypes.includes(file?.type);
}

export type FileValidationStateInvalid = "exceeded-size" | "wrong-format";

export type FileValidationStateValid = "valid";